import { sections } from '../../constants'

const supportedSections = [
  sections.header,
  sections.hero,
  sections.body,
  sections.lifestyle,
  sections.discoverIntro,
  sections.discoverButtons,
  sections.gallery,
  sections.footer
]

export default supportedSections
